import React from 'react';
import useDialog from '../hooks/useDialog';
import { useTranslation } from '../contexts/LanguageContext';
import { RANK_DISPLAY, rankTierName } from './RankBadge';
import useBodyScrollLock from '../hooks/useBodyScrollLock';
import './RankProgressionModal.css';

function RankProgressionModal({ show, ratingUpdate, onDismiss }) {
    const { t } = useTranslation();
    useBodyScrollLock(show && !!ratingUpdate);
    const dialogRef = useDialog(!!(show && ratingUpdate), onDismiss);
    if (!show || !ratingUpdate) return null;

    const { rankTier, rankName, rankColor, ratingAfter } = ratingUpdate;
    const display = RANK_DISPLAY[rankTier] || RANK_DISPLAY.bronze_3;

    return (
        <div className="modal-overlay-base rank-promotion-overlay" onClick={onDismiss}>
            <div className="modal-content-base rank-promotion-modal" data-modal-scrollable ref={dialogRef} role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
                <div className="rank-promotion-icon" style={{ color: rankColor }}>
                    <i className={`fas ${display.icon}`}></i>
                </div>
                <h2 className="rank-promotion-title">{t('rank.rankUp')}</h2>
                <p className="rank-promotion-name" style={{ color: rankColor }}>
                    {rankTierName(t, rankTier, rankName)}
                </p>
                <p className="rank-promotion-rating">
                    {t.rich('rank.ratingValue', { b: <strong /> }, { rating: ratingAfter })}
                </p>
                <button
                    className="rank-promotion-button"
                    style={{
                        background: `linear-gradient(135deg, ${rankColor} 0%, ${rankColor}cc 100%)`,
                    }}
                    onClick={onDismiss}
                >
                    {t('common.continue')}
                </button>
            </div>
        </div>
    );
}

export default RankProgressionModal;
